import React from 'react';
import { JobsiteScheduleStatusButton } from './JobsiteScheduleStatusButton';
import { JobsiteNotificationStatusButton } from './JobsiteNotificationStatusButton';
import { JobsiteScheduleDateSelector } from './JobsiteScheduleDateSelector';

export function JobsiteSchedulesNavigation(): React.ReactElement {
  return (
    <div className="odin-flex odin-flex-row odin-gap-4 odin-w-full odin-items-center">
      <JobsiteScheduleDateSelector />
      <JobsiteScheduleStatusButton />
      <JobsiteNotificationStatusButton />
    </div>
  );
}
